import { useEffect } from "react";
import { _AdquisitionContract, _single } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage"
import { PrintJson } from "../../../theme/Component/PrintJson";
import { BasicTable, MASK_DATE, MASK_NUMBER } from "../../../theme/Component/BasicTable";
import useModal, { MODAL_LG } from "../../../theme/Component/hooks/useModal";
import { Modal } from "../../../theme/Component/Modal";

export const DerechoTurno = () => {

    const _contract = useDataBean(_AdquisitionContract);
    const { lista, setLista, bean, setBean,handleChange } = _contract;
    const modalAdd = useModal("Turno",MODAL_LG);

    useEffect(() => {
       getRows();
    }, [])

    const getRows =()=>{
         _contract.instance.getPaymentAssignmentCatalogPorPropiedades({}, null).then(
            (resp: any) => {
                setLista(resp);
            }
        )
    }
      const head = [
        {title:'Turno',property:'TurnOrden',visible:true,mask:MASK_NUMBER},
        {title:'Nemonico',property:'UBLINVMnemonic',visible:true},
        {title:'Consecutivo',property:'UBLINVConsecutive',visible:true,mask:MASK_NUMBER},      
        {title:'Fecha',property:'Since',visible:true,mask:MASK_DATE},
    ]
      const iconButtonsItem = [
        { nombre: 'Agregar',visible:_single.canCreate(), icono: 'ri-file-add-line', evento: ()=>{addTurno()} }
    ]

    const addTurno=()=>{
        setBean({
            UBLINVMnemonic:'UBLINV',
            YearTurno:_single.getCurrenYear(),
            State:1,
            IDEmployee:_single.getAccountID(),
            Approving:1
        });
        modalAdd.open();
    }

    const agregar =()=>{
        _contract.instance.updatePaymentAssignment(bean).then(
            (resp:any)=>{
                getRows();
                modalAdd.close();
            }
        )
    }

    return (
        <BasicPage titulo="Derecho Turno">
            <div className="row">
                <div className="col">
                    <BasicTable iconButtons={iconButtonsItem} head={head} body={lista} rowSet={setBean}></BasicTable>
                    <Modal modal={modalAdd.modal} updateModal={modalAdd.setModal} eventModal={agregar}>
                        <div className="row">
                            <div className="col-md-6">
                                <label>No Turno</label>
                                <input type="number" className="form-control" name="TurnOrden" onChange={handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>UBLINV Consecutivo <small>(Causacion)</small></label>
                                <input type="number" className="form-control" name="UBLINVConsecutive" onChange={handleChange} />
                            </div>
                        </div>
                    </Modal>
                    {/* <PrintJson json={bean} /> */}
                </div>
            </div>
        </BasicPage>
    )
}